import React from 'react';
import createReactClass from 'create-react-class';
import {
    ControlLabel,
    FormControl,
    FormGroup
} from 'react-bootstrap';
import isValidEmail from 'validate.io-email-address';


var ModeratorInput = createReactClass({
    getInitialState: function () {
        return {
            name: '',
            email: ''
        };
    },

    nameChange: function (ev) {
        this.setState({ name: ev.target.value });
        this.props.onChange({
            name: ev.target.value,
            email: this.state.email
        });
    },

    emailChange: function (ev) {
        this.setState({ email: ev.target.value });
        this.props.onChange({
            name: this.state.name,
            email: ev.target.value
        });
    },

    render: function () {
        return <div className="add-moderator-form">
            <FormGroup key={1}>
                <ControlLabel>
                    Moderator name *
                </ControlLabel>

                <FormControl
                    onChange={this.nameChange}
                    type="text"
                    name="moderatorName"
                    value={this.state.name}
                />
            </FormGroup>

            <FormGroup key={2}>
                <ControlLabel>
                    Moderator email *
                </ControlLabel>

                <FormControl
                    onChange={this.emailChange}
                    type="text"
                    name="moderatorEmail"
                    value={this.state.email}
                />
            </FormGroup>

        </div>;
    }
});

ModeratorInput.isValid = function (state) {
    return state && state.name && isValidEmail(state.email);
};

export default ModeratorInput;
